export default "__VITE_ASSET__CoocLSbr__"